export default __webpack_public_path__ + "static/media/cancel.3b8487b1.svg";